import React from 'react';
import { CheckCircle, Clock, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import StarField from './StarField';

const BuildServiceSection = () => {
  const navigate = useNavigate();
  const services = [
    'Custom dial design',
    'Movement modification',
    'Luminous hands',
    'PVD coloured cases',
    'Bezel modification',
    'Custom Bracelets',
    'Anti reflective coated sapphire crystal mod',
  ];

  const process = [
    {
      step: '1',
      title: 'Consultation',
      description: 'Discuss your vision and requirements',
    },
    {
      step: '2',
      title: 'Design',
      description: 'Create a detailed plan for your build',
    },
    {
      step: '3',
      title: 'Build',
      description: 'Craft your custom timepiece',
    },
    {
      step: '4',
      title: 'Delivery',
      description: 'Receive your finished watch',
    },
  ];

  return (
    <section id="build-service" className="py-24 bg-black relative overflow-hidden">
      <StarField density="sparse" />
      <div className="container mx-auto px-6 max-w-6xl relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-4 tracking-tight">
            Custom Build Service
          </h2>
          <div className="w-20 h-1 bg-white mx-auto"></div>
          <p className="text-gray-400 font-light mt-4 max-w-2xl mx-auto">
            Bring your dream watch to life with professional custom building services
          </p>
        </div>

        {/* Availability Banner */}
        <div className="border-2 border-white/40 p-8 mb-16 text-center bg-white/5">
          <div className="flex items-center justify-center mb-4">
            <CheckCircle className="w-8 h-8 text-green-400 mr-3" />
            <span className="text-2xl font-light text-white">Currently Accepting Projects</span>
          </div>
          <p className="text-gray-300 font-light">
            I'm available for custom watch builds and modifications
          </p>
        </div>

        {/* Services Offered */}
        <div className="grid md:grid-cols-2 gap-16 mb-16">
          <div>
            <h3 className="text-2xl font-light text-white mb-6">Services Offered</h3>
            <ul className="space-y-4">
              {services.map((service, index) => (
                <li key={index} className="flex items-start text-gray-300 font-light">
                  <span className="w-2 h-2 bg-white rounded-full mt-2 mr-4 flex-shrink-0"></span>
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-light text-white mb-6">The Process</h3>
            <div className="space-y-6">
              {process.map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-12 h-12 border-2 border-white flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-white font-light text-lg">{item.step}</span>
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">{item.title}</h4>
                    <p className="text-gray-400 font-light text-sm">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-gray-300 font-light mb-6">
            Ready to start your custom build project?
          </p>
          <Button
            onClick={() => navigate('/contact')}
            size="lg"
            className="bg-white text-black hover:bg-gray-200 font-light px-12 py-6 text-lg transition-all duration-300 hover:scale-105"
          >
            <MessageSquare className="w-5 h-5 mr-2" />
            Get in Touch
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BuildServiceSection;
